// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { BASE_URL } from "../../config/axios";
// import Logo from "../../assets/images/logo.png"
// import DiwaliLogo from "../../assets/images/Purple Neon Diwali Greeting YouTube Video.gif"
// import { useNavigate } from "react-router-dom";
// import { Link } from 'react-router-dom'
// import usePermission from "../../config/permissions";
// import { ToastContainer, toast } from "react-toastify";
// import { EyeBottonInput, Eyebuttonwithline } from "../../components/AllSvg";
// import NewYearGif from "../../assets/gif/555.gif"
// import {
//   Eye,
//   EyeOff,
//   Lock,
//   Mail,
//   ArrowRight,
//   Shield,
//   CheckCircle,
//   UserCog,
//   Route,
//   FlaskConical,
//   Milestone
// } from "lucide-react";
// import "../../css/loginPage.css";

// const Login = () => {

//   const navigate = useNavigate();
//   const { updatePermissions } = usePermission(); // Use the hook

//   const [errMsg, setErrMsg] = useState("");
//   const [isLoading, setIsLoading] = useState(false);


//   const [formData, setFormData] = useState({
//     email: "",
//     password: ""
//   });



//   const [errors, setErrors] = useState({});

//   const [inputState, setInputState] = useState({});

//   const [showPassword, setShowPassword] = useState(false);


//   useEffect(() => {
//     // Check if the fields have been auto-filled by the browser
//     const emailInput = document.getElementById('email');
//     const passwordInput = document.getElementById('password');
//     if (emailInput && passwordInput) {
//       setFormData({
//         email: emailInput.value,
//         password: passwordInput.value
//       });
//       setInputState({
//         email: emailInput.value ? 'green' : '',
//         password: passwordInput.value ? 'green' : '',
//       });
//     }
//   }, []);



//   const validateForm = () => {
//     const newErrors = {};


//     if (!formData.email.trim()) {
//       newErrors.email = 'Email is required';
//     } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
//       newErrors.email = 'Invalid email format';
//     }

//     const requiredFields = [
//       'password',
//     ];

//     requiredFields.forEach(field => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
//       }
//     });

//     setErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };



//   const [loading, setLoading] = useState(false); //loading logic

//   const handleSubmit = async (e) => {
//     e.preventDefault();


//     if (validateForm()) {
//       setIsLoading(true);
//       const logingToastId = toast.loading("Authenticating...", {
//         position: "top-center",
//         theme: "colored"
//       });
//       try {
//         let res = await axios.post(`${BASE_URL}/user/login/`, formData);

//         if (res.status === 200) {
//           toast.dismiss(logingToastId);
//           toast.success("Welcome back! Redirecting... 🎉", {
//             position: "top-center",
//             autoClose: 1500,
//             theme: "colored"
//           });

//           setTimeout(() => {
//             window.location.reload();
//           }, 1500);

//           const { access, refresh, payload, employeecode, payload_a, letter, sitemanagement_sub_company, sitemanagement_role, sitemanagement_project, sitemanagement_emp_id, sitemanagement_emp_code } = res.data;

//           const sessionData = {
//             access_token: access || "",
//             refresh_token: refresh || "",
//             role: payload?.role || "",
//             email: payload?.email || "",
//             emp_code: employeecode || "",
//             department: payload_a?.department || "",
//             rh: payload_a?.reporting_head || "",
//             profilepic: payload_a?.profilepic || "",
//             letter_type: letter || "",
//             name: payload_a?.name || "",
//             company: payload_a?.division_name || "",
//             company_id: payload_a?.sub_company_id || "",
//             sitemanagement_role: sitemanagement_role || "",
//             sitemanagement_emp_id: sitemanagement_emp_id || "",
//             sitemanagement_emp_code: sitemanagement_emp_code || "",

//             sitemanagement_project: sitemanagement_project?.id || "",
//             sitemanagement_project_short_name: sitemanagement_project?.project_short_name || "",
//             sitemanagement_project_site_prcode: sitemanagement_project?.site_prcode || "",
//             sitemanagement_project_sub_company: sitemanagement_sub_company || "",


//           };


//           Object.entries(sessionData).forEach(([key, value]) => {
//             sessionStorage.setItem(key, value);
//           });

//           updatePermissions(); // Update permissions after setting session storage





//           // Navigate to the desired location after setting session data
//           if (sessionStorage) {
//             navigate("/");

//           }
//         } else {
//           setErrMsg("Invalid Email Or Password");
//         }
//       } catch (err) {
//         console.log(err);
//         setErrMsg(err.response.data.error);
//         // setErrMsg("Invalid Email Or Password");

//         //toast Logic
//         if (err.response) {
//           toast.dismiss(logingToastId);
//           const errorData = err.response.data;
//           if (typeof errorData.error === 'string') { // Single error message   
//             toast.error(`Error: ${errorData.error}`);
//           } else if (typeof errorData === 'object' && errorData !== null) {// Multiple error messages
//             Object.entries(errorData).forEach(([field, messages]) => {
//               messages.forEach(message => toast.error(`"${field}": ${message}`));
//             });
//           } else {
//             toast.error('Error:- Failed to Process!');
//           }
//         } else {
//           toast.error('Error processing your request.');
//         }

//       } finally {
//         setLoading(false);  //loading logic
//         // toast.dismiss(loadingToastId);
//       }
//     } else {
//       console.log('Form contains errors:', errors);

//     }
//   };


//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? 'green' : '',
//     });


//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };


//   const forgotpass = () => {
//     navigate("/forgotpassword");
//   }


//   const handleKeyPress = (event) => {
//     // Check if the pressed key is Enter (key code 13)
//     if (event.key === 'Enter') {
//       event.preventDefault();  // Prevent the default form submission
//       handleSubmit(event);
//     }
//   };
//   ;






//   return (
//     <>
//       <ToastContainer
//         position="top-center"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop={true}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored"
//       />

//       <div className="rs-login-container">
//         {/* Left Section - Branding */}
//         <div className="rs-login-left">

//           {/* Signature element: chainage / elevation survey profile line */}
//           <div className="rs-survey-profile" aria-hidden="true">
//             <svg viewBox="0 0 800 500" preserveAspectRatio="none">
//               <path
//                 className="rs-profile-fill"
//                 d="M0,420 L60,400 L140,410 L220,360 L300,370 L380,300 L460,320 L540,260 L620,280 L700,230 L800,250 L800,500 L0,500 Z"
//               />
//               <path
//                 className="rs-profile-path"
//                 d="M0,420 L60,400 L140,410 L220,360 L300,370 L380,300 L460,320 L540,260 L620,280 L700,230 L800,250"
//               />
//               <circle className="rs-benchmark" cx="140" cy="410" r="4" />
//               <circle className="rs-benchmark" cx="380" cy="300" r="4" />
//               <circle className="rs-benchmark" cx="620" cy="280" r="4" />
//               <text x="128" y="435" className="rs-chainage-label">CH 0+250</text>
//               <text x="368" y="325" className="rs-chainage-label">CH 1+800</text>
//               <text x="608" y="305" className="rs-chainage-label">CH 3+120</text>
//             </svg>
//           </div>

//           <div className="rs-login-left-content">
//             <div className="rs-login-logo-container">
//               <Link to="/">
//                 <img src={Logo} alt="Company Logo" className="rs-login-logo" />
//               </Link>

//               <p className="rs-eyebrow">Field Survey · Material Testing · Site Control</p>

//               <div className="rs-brand-row">
//                 <div className="rs-brand-icon">
//                   <Route size={28} />
//                 </div>
//                 <h1>Lab Tracking System</h1>
//               </div>

//               <p className="rs-tagline">
//                 One system for chainage-wise survey data, lab test results and site progress —
//                 from first pin to final layer.
//               </p>
//             </div>

//             <div className="rs-feature-list">
//               <div className="rs-feature-row">
//                 <div className="rs-feature-icon">
//                   <FlaskConical size={20} />
//                 </div>
//                 <div>
//                   <h4>Lab Test Records</h4>
//                   <p>Soil, aggregate &amp; asphalt test results logged against every sample</p>
//                 </div>
//               </div>
//               <div className="rs-feature-row">
//                 <div className="rs-feature-icon">
//                   <Milestone size={20} />
//                 </div>
//                 <div>
//                   <h4>Chainage-wise Progress</h4>
//                   <p>Track survey milestones point by point across the alignment</p>
//                 </div>
//               </div>
//               <div className="rs-feature-row">
//                 <div className="rs-feature-icon">
//                   <UserCog size={20} />
//                 </div>
//                 <div>
//                   <h4>Role-Based Access</h4>
//                   <p>Separate views for surveyors, lab technicians and site engineers</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Right Section - Login Form */}
//         <div className="rs-login-right">
//           <div className="rs-login-form-wrapper">
//             <div className="rs-login-form-card">
//               <div className="rs-form-header">
//                 <div className="rs-form-header-top">
//                   <div className="rs-header-icon">
//                     <Shield size={22} />
//                   </div>
//                   <div>
//                     <h2>Welcome back</h2>
//                   </div>
//                 </div>
//                 <p className="rs-header-subtitle">Sign in to access your survey dashboard</p>
//               </div>

//               <form
//                 onSubmit={handleSubmit}
//                 onKeyDown={handleKeyPress}
//                 className="rs-modern-login-form"
//               >
//                 <div className="rs-form-group">
//                   <label htmlFor="email" className="rs-form-label">
//                     <Mail size={16} />
//                     <span>Email Address</span>
//                   </label>
//                   <div className={`rs-input-container ${errors.email ? 'rs-input-error' : inputState.email ? 'rs-input-valid' : ''}`}>
//                     <input
//                       type="text"
//                       id="email"
//                       name="email"
//                       placeholder="Enter your work email"
//                       autoComplete="email"
//                       onChange={handleInputChange}
//                       value={formData.email}
//                       className="rs-form-input"
//                       disabled={isLoading}
//                     />
//                     {inputState.email === 'valid' && !errors.email && (
//                       <CheckCircle size={18} className="rs-input-icon-valid" />
//                     )}
//                   </div>
//                   {errors.email && (
//                     <span className="rs-error-message">
//                       {errors.email}
//                     </span>
//                   )}
//                 </div>

//                 <div className="rs-form-group">
//                   <label htmlFor="password" className="rs-form-label">
//                     <Lock size={16} />
//                     <span>Password</span>
//                   </label>
//                   <div className={`rs-input-container ${errors.password ? 'rs-input-error' : inputState.password ? 'rs-input-valid' : ''}`}>
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       placeholder="Enter your password"
//                       id="password"
//                       name="password"
//                       onChange={handleInputChange}
//                       value={formData.password}
//                       className="rs-form-input"
//                       disabled={isLoading}
//                     />
//                     <button
//                       type="button"
//                       className="rs-password-toggle"
//                       onClick={() => setShowPassword(!showPassword)}
//                       disabled={isLoading}
//                     >
//                       {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//                     </button>
//                   </div>
//                   {errors.password && (
//                     <span className="rs-error-message">
//                       {errors.password}
//                     </span>
//                   )}
//                 </div>

//                 <div className="rs-form-options">
//                   <button
//                     type="button"
//                     className="rs-forgot-password-link"
//                     onClick={forgotpass}
//                     disabled={isLoading}
//                   >
//                     Forgot Password?
//                   </button>
//                 </div>

//                 <button
//                   type="submit"
//                   className="rs-login-button"
//                   disabled={isLoading}
//                 >
//                   <span>{isLoading ? "Signing in..." : "Sign In"}</span>
//                   {!isLoading && <ArrowRight size={18} />}
//                 </button>

//                 {errMsg && (
//                   <div className="rs-error-alert">
//                     <Shield size={16} />
//                     <span>{errMsg}</span>
//                   </div>
//                 )}
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Login



import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import Logo from "../../assets/images/logo.png";
import { useNavigate, Link } from "react-router-dom";
import usePermission from "../../config/permissions";
import { ToastContainer, toast } from "react-toastify";
import {
  Eye,
  EyeOff,
  Lock,
  Mail,
  ArrowRight,
  Shield,
  CheckCircle,
  UserCog,
  Route,
  FlaskConical,
  Milestone,
} from "lucide-react";
import "../../css/loginPage.css";

const GREETINGS = [];

const Login = () => {
  const navigate = useNavigate();
  const { updatePermissions } = usePermission();

  const [errMsg, setErrMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [celebrate, setCelebrate] = useState(false);
  const [sparks, setSparks] = useState([]);
  const [gi, setGi] = useState(0);
  const rootRef = useRef(null);

  useEffect(() => {
    // Check if the fields have been auto-filled by the browser
    const emailInput = document.getElementById("email");
    const passwordInput = document.getElementById("password");
    if (emailInput && passwordInput) {
      setFormData({ email: emailInput.value, password: passwordInput.value });
      setInputState({
        email: emailInput.value ? "green" : "",
        password: passwordInput.value ? "green" : "",
      });
    }
  }, []);

  // Click sparkles
  useEffect(() => {
    const onClick = (e) => {
      const id = Date.now() + Math.random();
      setSparks((p) => [...p.slice(-6), { id, x: e.clientX, y: e.clientY }]);
      setTimeout(() => setSparks((p) => p.filter((s) => s.id !== id)), 800);
    };
    window.addEventListener("click", onClick);
    return () => window.removeEventListener("click", onClick);
  }, []);

  // Rotating Diwali greetings
  useEffect(() => {
    const t = setInterval(() => setGi((i) => (i + 1) % GREETINGS.length), 3000);
    return () => clearInterval(t);
  }, []);

  // Mouse parallax (sets CSS vars directly, no re-render)
  useEffect(() => {
    const el = rootRef.current;
    if (!el || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let raf = 0;
    const onMove = (e) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        el.style.setProperty("--mx", ((e.clientX / window.innerWidth) * 2 - 1).toFixed(3));
        el.style.setProperty("--my", ((e.clientY / window.innerHeight) * 2 - 1).toFixed(3));
      });
    };
    window.addEventListener("mousemove", onMove);
    return () => { window.removeEventListener("mousemove", onMove); cancelAnimationFrame(raf); };
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.password) {
      newErrors.password = "Password is required !";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsLoading(true);
      setErrMsg("");
      const logingToastId = toast.loading("Authenticating...", {
        position: "top-center",
        theme: "colored",
      });
      try {
        let res = await axios.post(`${BASE_URL}/user/login/`, formData);

        if (res.status === 200) {
          toast.dismiss(logingToastId);
          setCelebrate(true);
          toast.success("Welcome back! Redirecting... 🎉", {
            position: "top-center",
            autoClose: 1500,
            theme: "colored",
          });

          setTimeout(() => {
            window.location.reload();
          }, 1500);

          const {
            access, refresh, payload, employeecode, payload_a, letter,
            sitemanagement_sub_company, sitemanagement_role, sitemanagement_project,
            sitemanagement_emp_id, sitemanagement_emp_code,
          } = res.data;

          const sessionData = {
            access_token: access || "",
            refresh_token: refresh || "",
            role: payload?.role || "",
            email: payload?.email || "",
            emp_code: employeecode || "",
            department: payload_a?.department || "",
            rh: payload_a?.reporting_head || "",
            profilepic: payload_a?.profilepic || "",
            letter_type: letter || "",
            name: payload_a?.name || "",
            company: payload_a?.division_name || "",
            company_id: payload_a?.sub_company_id || "",
            sitemanagement_role: sitemanagement_role || "",
            sitemanagement_emp_id: sitemanagement_emp_id || "",
            sitemanagement_emp_code: sitemanagement_emp_code || "",
            sitemanagement_project: sitemanagement_project?.id || "",
            sitemanagement_project_short_name: sitemanagement_project?.project_short_name || "",
            sitemanagement_project_site_prcode: sitemanagement_project?.site_prcode || "",
            sitemanagement_project_sub_company: sitemanagement_sub_company || "",
          };

          Object.entries(sessionData).forEach(([key, value]) => {
            sessionStorage.setItem(key, value);
          });

          updatePermissions(); // Update permissions after setting session storage

          if (sessionStorage) {
            navigate("/");
          }
        } else {
          setErrMsg("Invalid Email Or Password");
        }
      } catch (err) {
        console.log(err);
        toast.dismiss(logingToastId);
        setErrMsg(err?.response?.data?.error || "Unable to sign in. Please try again.");

        if (err.response) {
          const errorData = err.response.data;
          if (typeof errorData.error === "string") {
            toast.error(`Error: ${errorData.error}`);
          } else if (typeof errorData === "object" && errorData !== null) {
            Object.entries(errorData).forEach(([field, messages]) => {
              messages.forEach((message) => toast.error(`"${field}": ${message}`));
            });
          } else {
            toast.error("Error:- Failed to Process!");
          }
        } else {
          toast.error("Error processing your request.");
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      console.log("Form contains errors:", errors);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState({ ...inputState, [name]: value.trim() ? "green" : "" });
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: "" });
    if (errMsg) setErrMsg("");
  };

  const forgotpass = () => {
    navigate("/forgotpassword");
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  /* ---------- Diwali decor data ---------- */
  const bulbColors = ["#ffc93c", "#ff8c1a", "#ff4d4d", "#ff7ab8", "#ffc93c", "#ff8c1a", "#ff4d4d", "#ff7ab8", "#ffc93c", "#ff8c1a", "#ff4d4d", "#ff7ab8", "#ffc93c", "#ff8c1a"];

  // Diwali countdown (edit date if needed)
  const DIWALI_DATE = new Date("2026-11-08T00:00:00");
  const today0 = new Date(); today0.setHours(0, 0, 0, 0);
  const daysLeft = Math.round((DIWALI_DATE - today0) / 86400000);
  const countdown = daysLeft > 1 ? `Diwali in ${daysLeft} days` : daysLeft === 1 ? "Diwali is tomorrow" : daysLeft === 0 ? "Happy Diwali today!" : "";

  const stars = Array.from({ length: 28 }, (_, i) => ({
    left: `${(i * 53 + 7) % 96}%`,
    top: `${(i * 31 + 11) % 70}%`,
    size: 1 + (i % 3),
    delay: (i % 7) * 0.5,
  }));

  const embers = Array.from({ length: 16 }, (_, i) => ({
    left: `${(i * 37 + 8) % 92}%`,
    size: 3 + (i % 4),
    dur: 7 + (i % 6) * 1.4,
    delay: (i % 8) * 0.9,
  }));

  const confetti = Array.from({ length: 44 }, (_, i) => ({
    left: `${(i * 23) % 100}%`,
    color: ["#ffc93c", "#ff8c1a", "#e8335a", "#fff3c4", "#ff7ab8"][i % 5],
    delay: (i % 11) * 0.06,
    dur: 1.3 + (i % 5) * 0.25,
    rot: (i * 47) % 360,
  }));

  const petals = Array.from({ length: 14 }, (_, i) => ({
    left: `${(i * 41 + 5) % 96}%`,
    size: 9 + (i % 4) * 3,
    dur: 9 + (i % 5) * 1.6,
    delay: (i % 7) * 1.1,
    color: ["#ff8c1a", "#ffc93c", "#e8590c", "#ffb347"][i % 4],
  }));

  // Diyas light up as the form is filled
  const litCount = (inputState.email === "green" ? 2 : 0) + (inputState.password === "green" ? 3 : 0);

  const Lantern = ({ className = "", color = "#ff8c1a" }) => (
    <svg className={`rs-lantern ${className}`} viewBox="0 0 60 120" aria-hidden="true">
      <line x1="30" y1="0" x2="30" y2="22" stroke="#c8860a" strokeWidth="2" />
      <rect x="22" y="20" width="16" height="8" rx="2" fill="#c8860a" />
      <path d="M14 30 Q30 22 46 30 L52 72 Q30 84 8 72 Z" fill={color} />
      <path d="M30 26 L30 78 M20 28 Q16 54 14 74 M40 28 Q44 54 46 74" stroke="rgba(58,10,28,0.45)" strokeWidth="1.5" fill="none" />
      <ellipse cx="30" cy="52" rx="8" ry="14" fill="#fff3c4" opacity="0.85" />
      <rect x="20" y="78" width="20" height="6" rx="2" fill="#c8860a" />
      <path d="M24 84 L22 112 M30 84 L30 116 M36 84 L38 112" stroke="#ffc93c" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );

  const Rangoli = ({ className = "" }) => (
    <svg className={`rs-rangoli ${className}`} viewBox="0 0 200 200" aria-hidden="true">
      <g fill="none" strokeWidth="2.2" strokeLinecap="round">
        <circle cx="100" cy="100" r="92" stroke="#ff8c1a" strokeDasharray="2 9" />
        <circle cx="100" cy="100" r="70" stroke="#c8860a" />
        {Array.from({ length: 12 }).map((_, i) => (
          <path key={i} d="M100 30 Q112 52 100 70 Q88 52 100 30Z" stroke="#e8590c" fill="rgba(255,201,60,0.55)" transform={`rotate(${i * 30} 100 100)`} />
        ))}
        {Array.from({ length: 8 }).map((_, i) => (
          <path key={`b${i}`} d="M100 74 Q110 88 100 100 Q90 88 100 74Z" stroke="#a31c4a" fill="rgba(255,140,26,0.6)" transform={`rotate(${i * 45} 100 100)`} />
        ))}
        <circle cx="100" cy="100" r="9" stroke="#c8860a" fill="#ffc93c" />
      </g>
    </svg>
  );

  const Diya = ({ className = "", lit = true }) => (
    <svg className={`rs-diya ${lit ? "" : "rs-diya-off"} ${className}`} viewBox="0 0 64 56" aria-hidden="true">
      <path className="rs-flame-outer" d="M32 2C24 12 24 22 32 26C40 22 40 12 32 2Z" />
      <path className="rs-flame-inner" d="M32 12C29 16 29 21 32 23C35 21 35 16 32 12Z" />
      <path className="rs-diya-bowl" d="M4 28H60C58 44 46 52 32 52C18 52 6 44 4 28Z" />
      <path className="rs-diya-rim" d="M4 28H60" />
    </svg>
  );

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="rs-login-container" ref={rootRef}>
        {/* Left Section - Branding */}
        <div className="rs-login-left">
          {/* String lights */}
          <div className="rs-lights" aria-hidden="true">
            {bulbColors.map((c, i) => (
              <span key={i} className="rs-bulb" style={{ "--bulb": c, animationDelay: `${(i % 5) * 0.35}s` }} />
            ))}
          </div>

          <div className="rs-stars" aria-hidden="true">
            {stars.map((st, i) => (
              <i key={i} style={{ left: st.left, top: st.top, width: st.size, height: st.size, animationDelay: `${st.delay}s` }} />
            ))}
          </div>
          <span className="rs-burst rs-burst-1" aria-hidden="true" />
          <span className="rs-burst rs-burst-2" aria-hidden="true" />
          <span className="rs-burst rs-burst-3" aria-hidden="true" />
          <span className="rs-burst rs-burst-4" aria-hidden="true" />
          <Lantern className="rs-lantern-a" color="#ff8c1a" />
          <Lantern className="rs-lantern-b" color="#e8335a" />

          {/* Signature element: chainage / elevation survey profile line */}
          <div className="rs-survey-profile" aria-hidden="true">
            <svg viewBox="0 0 800 500" preserveAspectRatio="none">
              <path
                className="rs-profile-fill"
                d="M0,420 L60,400 L140,410 L220,360 L300,370 L380,300 L460,320 L540,260 L620,280 L700,230 L800,250 L800,500 L0,500 Z"
              />
              <path
                id="rs-route"
                className="rs-profile-path"
                d="M0,420 L60,400 L140,410 L220,360 L300,370 L380,300 L460,320 L540,260 L620,280 L700,230 L800,250"
              />
              <circle className="rs-halo" cx="140" cy="410" r="12" />
              <circle className="rs-halo" cx="380" cy="300" r="12" style={{ animationDelay: "0.8s" }} />
              <circle className="rs-halo" cx="620" cy="280" r="12" style={{ animationDelay: "1.6s" }} />
              <circle className="rs-benchmark" cx="140" cy="410" r="4" />
              <circle className="rs-benchmark" cx="380" cy="300" r="4" />
              <circle className="rs-benchmark" cx="620" cy="280" r="4" />
              <circle className="rs-traveller" r="5">
                <animateMotion dur="10s" begin="3s" repeatCount="indefinite">
                  <mpath href="#rs-route" />
                </animateMotion>
              </circle>
              <text x="128" y="435" className="rs-chainage-label">CH 0+250</text>
              <text x="368" y="325" className="rs-chainage-label">CH 1+800</text>
              <text x="608" y="305" className="rs-chainage-label">CH 3+120</text>
            </svg>
          </div>

          <div className="rs-embers" aria-hidden="true">
            {embers.map((e, i) => (
              <i key={i} style={{ left: e.left, width: e.size, height: e.size, animationDuration: `${e.dur}s`, animationDelay: `${e.delay}s` }} />
            ))}
          </div>

          <div className="rs-login-left-content">
            <div className="rs-login-logo-container">
              <Link to="/">
                <img src={Logo} alt="Company Logo" className="rs-login-logo" />
              </Link>

              <p className="rs-eyebrow">Field Survey · Material Testing · Site Control</p>

              <div className="rs-brand-row">
                <div className="rs-brand-icon">
                  <Route size={28} />
                </div>
                <h1>Lab Tracking System</h1>
                <Diya className="rs-diya-brand" />
              </div>

              <p className="rs-hindi" lang="hi">Happy Diwali</p>
              <p className="rs-greet" key={gi} lang={gi === 1 ? "hi" : undefined} aria-live="off">{GREETINGS[gi]}</p>
              <p className="rs-wish">✨ Wishing you a Happy &amp; Prosperous Diwali ✨</p>
              {countdown && <span className="rs-countdown">🪔 {countdown}</span>}

              <p className="rs-tagline">
                One system for chainage-wise survey data, lab test results and site progress —
                from first pin to final layer.
              </p>
            </div>

            <div className="rs-feature-list">
              <div className="rs-feature-row">
                <div className="rs-feature-icon"><FlaskConical size={20} /></div>
                <div>
                  <h4>Lab Test Records</h4>
                  <p>Soil, aggregate &amp; asphalt test results logged against every sample</p>
                </div>
              </div>
              <div className="rs-feature-row">
                <div className="rs-feature-icon"><Milestone size={20} /></div>
                <div>
                  <h4>Chainage-wise Progress</h4>
                  <p>Track survey milestones point by point across the alignment</p>
                </div>
              </div>
              <div className="rs-feature-row">
                <div className="rs-feature-icon"><UserCog size={20} /></div>
                <div>
                  <h4>Role-Based Access</h4>
                  <p>Separate views for surveyors, lab technicians and site engineers</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section - Login Form */}
        <div className="rs-login-right">
          <div className="rs-petals" aria-hidden="true">
            {petals.map((p, i) => (
              <i key={i} style={{ left: p.left, width: p.size, height: p.size, background: p.color, animationDuration: `${p.dur}s`, animationDelay: `${p.delay}s` }} />
            ))}
          </div>
          <Rangoli className="rs-rangoli-tr" />
          <Rangoli className="rs-rangoli-bl" />

          <div className="rs-login-form-wrapper">
            <div className="rs-login-form-card">
              <div className="rs-form-header">
                <div className="rs-form-header-top">
                  <div className="rs-header-icon">
                    <Shield size={22} />
                  </div>
                  <h2>Welcome back</h2>
                  <Diya className="rs-diya-form" />
                </div>
                <p className="rs-header-subtitle">Sign in to access your survey dashboard</p>
              </div>

              <form onSubmit={handleSubmit} onKeyDown={handleKeyPress} className="rs-modern-login-form" noValidate>
                <div className="rs-form-group">
                  <label htmlFor="email" className="rs-form-label">
                    <Mail size={16} />
                    <span>Email Address</span>
                  </label>
                  <div className={`rs-input-container ${errors.email ? "rs-input-error" : inputState.email ? "rs-input-valid" : ""}`}>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      placeholder="Enter your work email"
                      autoComplete="email"
                      onChange={handleInputChange}
                      value={formData.email}
                      className="rs-form-input"
                      disabled={isLoading}
                    />
                    {inputState.email === "green" && !errors.email && (
                      <CheckCircle size={18} className="rs-input-icon-valid" />
                    )}
                  </div>
                  {errors.email && <span className="rs-error-message">{errors.email}</span>}
                </div>

                <div className="rs-form-group">
                  <label htmlFor="password" className="rs-form-label">
                    <Lock size={16} />
                    <span>Password</span>
                  </label>
                  <div className={`rs-input-container ${errors.password ? "rs-input-error" : inputState.password ? "rs-input-valid" : ""}`}>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      id="password"
                      name="password"
                      autoComplete="current-password"
                      onChange={handleInputChange}
                      value={formData.password}
                      className="rs-form-input"
                      disabled={isLoading}
                    />
                    <button
                      type="button"
                      className="rs-password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                      disabled={isLoading}
                      aria-label={showPassword ? "Hide password" : "Show password"}
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                  {errors.password && <span className="rs-error-message">{errors.password}</span>}
                </div>

                <div className="rs-form-options">
                  <button type="button" className="rs-forgot-password-link" onClick={forgotpass} disabled={isLoading}>
                    Forgot Password?
                  </button>
                </div>

                <button type="submit" className="rs-login-button" disabled={isLoading}>
                  <span>{isLoading ? "Signing in..." : "Sign In"}</span>
                  {!isLoading && <ArrowRight size={18} />}
                </button>

                {errMsg && (
                  <div className="rs-error-alert" role="alert">
                    <Shield size={16} />
                    <span>{errMsg}</span>
                  </div>
                )}
              </form>

              <p className="rs-form-footer">🪔 Celebrate safely — keep every site fire-safe this Diwali.</p>
            </div>

            <div className="rs-diya-row" aria-hidden="true">
              {[0, 1, 2, 3, 4].map((i) => (
                <Diya key={i} className="rs-diya-mini" lit={isLoading || i < litCount} />
              ))}
            </div>
          </div>
        </div>
      </div>

      {sparks.map((sp) => (
        <span key={sp.id} className="rs-spark" style={{ left: sp.x, top: sp.y }} aria-hidden="true">
          {[0, 1, 2, 3, 4, 5, 6, 7].map((k) => (
            <i key={k} style={{ "--a": `${k * 45}deg` }} />
          ))}
        </span>
      ))}

      {celebrate && (
        <div className="rs-celebrate" aria-hidden="true">
          <span className="rs-big-burst rs-big-burst-1" />
          <span className="rs-big-burst rs-big-burst-2" />
          <span className="rs-big-burst rs-big-burst-3" />
          <div className="rs-celebrate-msg">
            <Diya className="rs-diya-celebrate" />
            <strong>शुभ दीपावली!</strong>
            <span>Signing you in…</span>
          </div>
        </div>
      )}

      {celebrate && (
        <div className="rs-confetti" aria-hidden="true">
          {confetti.map((c, i) => (
            <i key={i} style={{ left: c.left, background: c.color, animationDelay: `${c.delay}s`, animationDuration: `${c.dur}s`, "--r": `${c.rot}deg` }} />
          ))}
        </div>
      )}
    </>
  );
};

export default Login;